import { AmplitudeFlagKey } from "@simplyk/common";

import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { useAmplitudeFeatureFlag } from "@/common/hooks/amplitude/useAmplitudeFeatureFlag";

export const useMagicEmailFlowFlag = () => {
  const { organization, userIsLoading } = useCurrentUserContext();

  const { isActive: isFlagActive, loading: isFlagLoading } = useAmplitudeFeatureFlag({
    flagKey: AmplitudeFlagKey.MagicEmailFlow,
    organizationId: organization?.id,
    userProperties: { organizationId: organization?.id || "" },
    skip: !organization?.id,
  });

  const loading = userIsLoading || isFlagLoading;
  const isActive = isFlagActive;

  return {
    isActive,
    loading,
  };
};
